import { prop } from 'ramda';
import { useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { getCleanUrl } from 'js/utils/url.util';
import { usePageSelector } from 'js/store/hooks';

export const useLeaderBoardId = () => {
    const { leaderboardId } = useParams();
    const cachedLeaderboardId = useRef();
    const popupBackgroundPagePath = usePageSelector(prop('popupBackgroundPagePath'));

    return useMemo(() => {
        if (leaderboardId) {
            cachedLeaderboardId.current = leaderboardId;

            return leaderboardId;
        }

        const idFromBackgroundPage = getCleanUrl(popupBackgroundPagePath)
            .split('/')
            .pop();

        if (idFromBackgroundPage) {
            cachedLeaderboardId.current = leaderboardId;

            return idFromBackgroundPage;
        }

        return cachedLeaderboardId.current;
    }, [leaderboardId, popupBackgroundPagePath]);
};
